import { Component, AfterViewInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss']
})
export class HeroComponent implements AfterViewInit {

  public element: any;
  public sidePanel: any;
  // Both schedule overlays parallax together; only the free one fades.
  public scheduleLayers: any[] = [];
  public freeLayers: any[] = [];
  private animationFrame: number = null;
  private requestAnimationFrame = typeof window !== 'undefined' ? window.requestAnimationFrame : undefined;

  private cancelAnimationFrame = typeof window !== 'undefined' ? window.cancelAnimationFrame : undefined;

  @ViewChild('preview', { static: false }) public previewElement!: any;
  @ViewChild('previewFrame', { static: false }) public previewFrameElement!: any;

  mode:'static'|'preview' = 'static';

  constructor(private el: ElementRef, private cdRef : ChangeDetectorRef) {
    this.element = el.nativeElement;
  }

  // The room is shown as free once past the scroll threshold: the dark schedule
  // and the dark button band fade in over the busy artwork underneath.
  setFreeState(free) {
    for (let i = 0; i < this.freeLayers.length; i++) {
      this.freeLayers[i].style.opacity = free ? 1 : 0;
    }
  }

  ngAfterViewInit() {
    this.sidePanel = this.element.querySelector('.sidePanelContent');

    this.scheduleLayers = Array.prototype.slice.call(this.element.querySelectorAll('.sidePanelContent'));
    this.freeLayers = Array.prototype.slice.call(
      this.element.querySelectorAll('.sidePanelContent.free, .sidePanelFooter.free'));

    if (typeof window === 'undefined') {
      return;
    }

    const bgObj = this.sidePanel;

    const execute = () => {

        if (bgObj == null) {
          return;
        }

        if (window.innerWidth < 768) {
          this.scheduleLayers.forEach((layer) => layer.style.transform = null);
          this.setFreeState(false);
          return;
        }

        let distance = Math.min(1.32, window.scrollY / window.innerHeight);
        distance = distance / 2;

        this.setFreeState(distance >= 0.2);

        const callback = () => {
          const offset = 'translate3d(0, -' + (distance * bgObj.clientHeight / 4) + 'px, 0)';
          // Both overlays have to move in lockstep or the crossfade would slide.
          this.scheduleLayers.forEach((layer) => layer.style.transform = offset);
        };

        if (typeof this.requestAnimationFrame !== 'undefined' && this.requestAnimationFrame != null) {
          if (typeof this.cancelAnimationFrame !== 'undefined' && this.animationFrame != null) {
            this.cancelAnimationFrame(this.animationFrame);
          }
          this.animationFrame = this.requestAnimationFrame(callback);
        } else {
          callback();
        }


    };

    window.document.addEventListener('scroll', () => {
      execute();
    });

    // Defer the first run past the initial paint (stand-in for afterNextRender,
    // unavailable pre-Angular-16) so hydration reconciles against the
    // server-rendered styles before we mutate them.
    if (typeof this.requestAnimationFrame !== 'undefined' && this.requestAnimationFrame != null) {
      this.requestAnimationFrame(execute);
    } else {
      execute();
    }
  }

  getPreviewWidth = () => {
    if(this.previewElement) {
      return this.previewElement?.nativeElement.clientWidth;
    }
    return 0;
  }

  getPreviewHeight = () => {
    if(this.previewElement) {
      return this.previewElement?.nativeElement.clientHeight;
    }
    return 0;
  }

  getIframeWidth = () => {
    return 1024;//Math.min(this.getPreviewWidth(), this.previewElement?.nativeElement.clientHeight * 1.7777777777777777777777777777778);
  }

  getIframeHeight = () => {
    return 768;
  }

  getScaleFactor = () => {
    console.log('getScaleFactor', this.getIframeWidth(), this.getPreviewWidth());
    return this.getPreviewWidth() / this.getIframeWidth();
  }

  activatePreview = (event:any) => {
    if(event?.preventDefault) {
      event.preventDefault();
    }
    this.mode = 'preview';
    this.cdRef.detectChanges();
  }

}
